import React, {useEffect} from "react";
import {Grid, Paper, FormControl, TextField} from "@material-ui/core"
import _ from "lodash";
import {useFieldWithValidation} from "../../../../../hooks";
import InputComboBox from "../../../sharedFormComponents/InputComboBox";
import SingleAutoComplete from "../../../shared/SingleAutoComplete";

const LocationSection = (
    {
        investor, isEditing,
        handleOnChange, handleOnChangeInField,
        handleOnError, session, countries, countriesByRegion,
        regions, states, ...props
    }
) => {
    const unitedStatesId = countries.find((country) => country.name === "United States")?.id;
    const countryOptions = countriesByRegion[investor?.region_id];
    const {reset: resetCity, validate: validateCity, errorMessage: cityErrorMessage, ...city} = useFieldWithValidation(
        "text",
        investor.city || "",
        () => true,
        false,
        ({target:{ name, value }}) => handleOnChangeInField(name, value)
    );
    const {reset: resetAddress1, validate: validateAddress1, errorMessage: address1ErrorMessage, ...address1} = useFieldWithValidation(
        "text",
        investor.address1 || "",
        () => true,
        false,
        ({target:{ name, value }}) => handleOnChangeInField(name, value)
    );
    const {reset: resetAddress2, validate: validateAddress2, errorMessage: address2ErrorMessage, ...address2} = useFieldWithValidation(
        "text",
        investor.address2 || "",
        () => true,
        false,
        ({target:{ name, value }}) => handleOnChangeInField(name, value)
    );
    const {reset: resetZipCode, validate: validateZipCode, errorMessage: zipCodeErrorMessage, ...zip_code} = useFieldWithValidation(
        "text",
        investor.zip_code || "",
        () => true,
        false,
        ({target:{ name, value }}) => handleOnChangeInField(name, value)
    );

    const validRegion = () => {
        return _.isNumber(investor.region_id)
    }

    const validCountry = () => {
        return countryOptions?.some((countryOption) => countryOption.id === investor?.country_id)
    }

    const requiredErrors = () => {
        return !validRegion() || !validCountry()
    }

    useEffect(() => {
        handleOnError(requiredErrors());
    }, [
        investor.region_id, investor.country_id, countryOptions
    ]);

    const handleRegionChange = (regionId) => {
        handleOnChangeInField('state', null)
        handleOnChangeInField('country_id', null)
        handleOnChangeInField('region_id', regionId)
    }

    const handleCountryChange = (countryId) => {
        if (unitedStatesId === countryId) {
            handleOnChangeInField('state', null)
        }
        handleOnChangeInField('country_id', countryId)
    }

    return (
        <Grid container item xs={12}>
            <Paper className="form-container" elevation={3}>
                <Grid item xs={12}>
                    <h3>Location</h3>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <SingleAutoComplete
                            options={regions}
                            handleOnChange={(value) => handleRegionChange(value?.id || null)}
                            handleOnError={() => !validRegion()}
                            selectedId={investor.region_id}
                            field={'region_id'}
                            label={"Regions"}
                            variant={"outlined"}
                            className="entity-autocomplete"
                            autoHighlight
                            required
                        />
                    </Grid>

                    <Grid item xs={3}>
                        {
                            ![null, undefined, ""].includes(investor.region_id) && <SingleAutoComplete
                                options={countryOptions}
                                handleOnChange={(value) => handleCountryChange(value?.id || null)}
                                handleOnError={() => !validCountry()}
                                selectedId={investor.country_id}
                                field={'country_id'}
                                label={"Countries"}
                                variant={"outlined"}
                                className="entity-autocomplete"
                                autoHighlight
                                required
                            />
                        }
                    </Grid>

                    <Grid item xs={3}>
                        {
                            investor.country_id === unitedStatesId && <SingleAutoComplete
                                options={states}
                                handleOnChange={(value) => handleOnChangeInField('state', value?.id || null)}
                                handleOnError={() => {}}
                                selectedId={investor.state}
                                field={'state'}
                                label={"States"}
                                variant={"outlined"}
                                className="entity-autocomplete"
                                autoHighlight
                            />
                        }
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                {...city}
                                label={"City"}
                                name={"city"}
                                maxLength={80}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                {...address1}
                                label={"Address 1"}
                                name={"address1"}
                                maxLength={40}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                {...address2}
                                label={"Address 2"}
                                name={"address2"}
                                maxLength={40}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <TextField
                                variant="outlined"
                                {...zip_code}
                                label={"Zip Code"}
                                name={"zip_code"}
                                maxLength={40}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
}

export default LocationSection;